import React, { useEffect, useState } from 'react';
import { List, Skeleton, Tooltip, Button, Modal } from 'antd';
import { BookOutlined, CalendarOutlined, FileTextOutlined, PaperClipOutlined, EyeOutlined, ExportOutlined } from '@ant-design/icons';
import SimpleBarReact from "simplebar-react";
import axios from 'axios';
// import { Editor } from '@tinymce/tinymce-react';
import Utils from '../../../misc/Utils';
import moment from 'moment';
import Wysiwyg from '../../../components/wysiwyg/wysiwyg';
import DocumentViewer from '../../../components/document-viewer/DocumentViewer';
import './Submissions.css';
import { decorateMicrocredentialRecord, parseMicrocredentialSubjectCode } from '../microcredentialUtils';

export default function Details(props) {
   const [homeworkData, setHomeworkData] = useState(null);
   const [uploadedFiles, setUploadedFiles] = useState([]);
   const [previewDocument, setPreviewDocument] = useState(null);
   const [previewDocumentName, setPreviewDocumentName] = useState(null);
   const [previewModalVisible, setPreviewModalVisible] = useState(false);
   const subdomain = localStorage.getItem("lms-subdomain");

   useEffect(() => {
      Utils.verifyJwt();

      getHomeworkInfo(props.homeworkID);
   }, [props.homeworkID]);

   const getHomeworkInfo = (id) => {
      axios.get(`${process.env.REACT_APP_API_HOMEWORK}/info?id=${id}`).then((response) => {
         if (response.data) {
            var data = response.data[0];
            setHomeworkData(decorateMicrocredentialRecord(data));
            const docs = data.document ? data.document.split(',').filter(item => item && item.trim() !== '') : [];
            setUploadedFiles(docs);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handlePreviewUploaded = (item) => {
      setPreviewDocument(`${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}/${item}`);
      setPreviewDocumentName(item);
      setPreviewModalVisible(true);
   }

   const handleClosePreview = () => {
      setPreviewModalVisible(false);
      setPreviewDocument(null);
      setPreviewDocumentName(null);
   }

   const microcredentialMetadata = parseMicrocredentialSubjectCode(homeworkData?.subject_code);
   const isMicrocredentialRecord = !!microcredentialMetadata;
   const microcredentialCourse = microcredentialMetadata?.course_name || homeworkData?.subject || '';
   const microcredentialTopic = microcredentialMetadata?.topic_title || '';
   return (
      <>
         {homeworkData !== null
            ?
            <>
               <div className="homework-panel-header">
                  <div>
                     <span className="homework-panel-kicker">{isMicrocredentialRecord ? 'Microcredential' : 'Homework'}</span>
                     <h3>Details</h3>
                  </div>
                  <FileTextOutlined />
               </div>

               <div className="homework-detail-summary">
                  <div className="homework-detail-hero">
                     <span>Title</span>
                     <strong>{homeworkData.title}</strong>
                  </div>

                  <div className="homework-detail-meta-grid">
                     <div className="homework-detail-meta">
                        <div className="homework-detail-meta-label">
                           <CalendarOutlined />
                           <span>Homework Date</span>
                        </div>
                        <strong>{moment(homeworkData.homework_date).format('MMM. DD, YYYY')}</strong>
                     </div>
                     <div className="homework-detail-meta">
                        <div className="homework-detail-meta-label">
                           <CalendarOutlined />
                           <span>Submission Date</span>
                        </div>
                        <strong>{moment(homeworkData.submit_date).format('MMM. DD, YYYY')}</strong>
                     </div>
                     <div className="homework-detail-meta">
                        <div className="homework-detail-meta-label">
                           <BookOutlined />
                           <span>Level</span>
                        </div>
                        <strong>{homeworkData.level}</strong>
                     </div>
                     {isMicrocredentialRecord ? (
                        <>
                           <div className="homework-detail-meta">
                              <div className="homework-detail-meta-label">
                                 <BookOutlined />
                                 <span>Course</span>
                              </div>
                              <strong>{microcredentialCourse}</strong>
                              <div className="homework-detail-meta-label">
                                 <BookOutlined />
                                 <span>Topic</span>
                              </div>
                              <strong>{microcredentialTopic || '-'}</strong>
                           </div>
                        </>
                     ) : (
                        <div className="homework-detail-meta">
                           <div className="homework-detail-meta-label">
                              <BookOutlined />
                              <span>Subject</span>
                           </div>
                           <strong>{homeworkData.subject}</strong>
                        </div>
                     )}
                  </div>
               </div>

               <div className="homework-field-block">
                  <label>Description</label>
                  <div className="homework-description-box">
                     <Wysiwyg
                        content={homeworkData.description}
                        height={150}
                        contentHeight={135}
                        disabled={true}
                     />
                  </div>
               </div>

               <div className="homework-field-block">
                  <label>
                     <PaperClipOutlined />
                     Attached Documents
                  </label>
                  {uploadedFiles.length > 0
                     ?
                     <>
                        <SimpleBarReact className="homework-document-list-scroll">
                           <List
                              size="small"
                              dataSource={uploadedFiles}
                              className="homework-document-list"
                              renderItem={item =>
                                 <List.Item
                                    actions={[
                                       <Tooltip key="preview" placement="top" title='Preview'>
                                          <Button
                                             type="text"
                                             size="small"
                                             shape="circle"
                                             icon={<EyeOutlined />}
                                             onClick={() => handlePreviewUploaded(item)}
                                          />
                                       </Tooltip>,
                                       <Tooltip key="open" placement="top" title='Open in new tab'>
                                          <a
                                             href={`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}/${item}`}
                                             target="_blank"
                                             rel="noreferrer"
                                          >
                                             <ExportOutlined />
                                          </a>
                                       </Tooltip>
                                    ]}
                                 >
                                    <Tooltip placement="right" title={item}>
                                       <span className="homework-modal-uploaded-file">{Utils.GetFileIcon(item)} {item}</span>
                                    </Tooltip>
                                 </List.Item>
                              }
                           />
                        </SimpleBarReact>
                     </>
                     :
                     <div className="homework-empty-documents">No attached documents</div>
                  }
               </div>
            </>
            :
            <div className="homework-panel-skeleton">
               <Skeleton.Input active className="homework-skeleton-title" />
               <Skeleton active paragraph={{ rows: 3 }} title={false} />
               <Skeleton.Input active className="homework-skeleton-title" />
               <Skeleton active paragraph={{ rows: 2 }} title={false} />
            </div>
         }

         <Modal
            title="Document Preview"
            // className="homework-assignment-modal homework-document-preview-modal"
            centered
            destroyOnClose={true}
            open={previewModalVisible}
            width="80%"
            footer={[
               <Button key="close" shape="round" onClick={() => handleClosePreview()}>
                  Close
               </Button>
            ]}
            onCancel={() => handleClosePreview()}
         >
            <div className='modal-document-viewer homework-document-preview-viewer'>
               <DocumentViewer
                  document={previewDocument}
                  documentname={previewDocumentName}
                  dvheight="calc(100dvh - 220px)"
                  ismodal={true}
               />
            </div>
         </Modal>
      </>
   )
}
